export function getHourDifferenceFromUTC(timeZone: string) {
  try {
    const now = new Date()
    const utc = now.getTime() + now.getTimezoneOffset() * 60000
    const targetTime = new Date(now.toLocaleString('en-US', { timeZone }))
    const timeDifference = targetTime.getTime() - utc

    return Math.round(timeDifference / (1000 * 60 * 60))
  } catch (error) {
    console.error('Error getting hour difference from UTC:', error)
    return 0
  }
}
